import { render, staticRenderFns } from "./CaseOxygens.vue?vue&type=template&id=50d92cfc&scoped=true&"
import script from "./CaseOxygens.vue?vue&type=script&lang=js&"
export * from "./CaseOxygens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d92cfc",
  null
  
)

export default component.exports